import React from "react";

function DistanceIcon() {
    return (
        <svg
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g transform="translate(-.999)">
                <g
                    transform="translate(8.519 14.355)"
                    data-name="Group 76"
                >
                    <g data-name="Group 75">
                        <path
                            transform="translate(-12 -21)"
                            d="M19.519,22.367H12.684a.684.684,0,0,1,0-1.367h6.836a.684.684,0,1,1,0,1.367Z"
                            fill="#fff"
                            data-name="Path 34"
                        />
                    </g>
                </g>
                <g
                    transform="translate(8.519 7.519)"
                    data-name="Group 78"
                >
                    <g data-name="Group 77">
                        <path
                            transform="translate(-12 -11)"
                            d="M19.519,12.367H12.684a.684.684,0,0,1,0-1.367h6.836a.684.684,0,1,1,0,1.367Z"
                            fill="#fff"
                            data-name="Path 35"
                        />
                    </g>
                </g>
                <g
                    transform="translate(8.519 .684)"
                    data-name="Group 80"
                >
                    <g data-name="Group 79">
                        <path
                            transform="translate(-12 -1)"
                            d="M19.519,2.367H12.684a.684.684,0,0,1,0-1.367h6.836a.684.684,0,1,1,0,1.367Z"
                            fill="#fff"
                            data-name="Path 36"
                        />
                    </g>
                </g>
                <path
                    transform="translate(0)"
                    d="M5.955,12.988H4.418V3.418H5.955a.513.513,0,0,0,.376-.862L4.109.163a.514.514,0,0,0-.751,0L1.136,2.556a.513.513,0,0,0,.375.862H3.05v9.57H1.512a.513.513,0,0,0-.376.862l2.222,2.393a.514.514,0,0,0,.752,0L6.331,13.85a.515.515,0,0,0,.137-.349.525.525,0,0,0-.042-.205.513.513,0,0,0-.47-.308Z"
                    fill="#fff"
                    data-name="Path 37"
                />
            </g>
        </svg>
    );
}

export default DistanceIcon;
